import {
  FETCH_ADMINS_PARK_REQUEST,
  FETCH_ADMINS_PARK_SUCCESS,
  FETCH_ADMINS_PARK_FAILURE,
  DELETE_ADMIN_PARK_REQUEST,
  DELETE_ADMIN_PARK_SUCCESS,
  DELETE_ADMIN_PARK_FAILURE,
} from "../actions/AdminParkActions";

const initialState = {
  admins: [],
  loading: false,
  error: null,
};

const adminParkReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADMINS_PARK_REQUEST:
      return { ...state, loading: true, error: null };

    case FETCH_ADMINS_PARK_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: action.payload,   // ✅ FIXED
        error: null,
      };

    case FETCH_ADMINS_PARK_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case DELETE_ADMIN_PARK_REQUEST:
      return { ...state, loading: true, error: null };

    case DELETE_ADMIN_PARK_SUCCESS:
      return {
        ...state,
        loading: false,
        admins: state.admins.filter((a) => a.id !== action.payload),
        error: null,
      };

    case DELETE_ADMIN_PARK_FAILURE:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};

export default adminParkReducer;
